import React, { useEffect, useState } from 'react';
import Modal from '../components/modal';
import Button from '../components/button';
import Input from '../components/input';
import formatCurrency from '../utils/formatCurrency';
import { useAuthContext } from '../context/Auth';
import api from '../utils/api';
import ItemBillet from './item-billet';
import { isMobile } from 'react-device-detect';
import Snackbar from '../components/snackbar';

const Billets = () => {

    const [description, setDescription] = useState('');
    const [fine, setFine] = useState('');
    const [interest, setInterest] = useState('');
    const { receiversOptions, userInfos } = useAuthContext();
    const [isLoadingNew, setIsLoadingNew] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [billets, setBillets] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);  // Controlando a abertura e fechamento do modal
    const [billetValue, setBilletValue] = useState('');
    const [dueDate, setDueDate] = useState();
    const [receivers, setReceivers] = useState([
        { receiver_id: '', percentage: 0 }
    ]);
    const [error, setError] = useState('');
    const [snackbar, setSnackbar] = useState({ message: '', type: 'error', visible: false });

    const handleReceiverChange = (index, value) => {
        if (value === '') {
            // Permite que o usuário apague o campo
            const newReceivers = [...receivers];
            newReceivers[index].percentage = '';
            setReceivers(newReceivers);
            return;
        }
    
        const percentage = Math.min(100, Number(value)); // Limita a 100 sem forçar 0
        const newReceivers = [...receivers];
        newReceivers[index].percentage = percentage;
        setReceivers(newReceivers);
    };    

    const handleReceiverPercentageChange = (index, value) => {
        const newReceivers = [...receivers];
        newReceivers[index].receiver_id = value;
        setReceivers(newReceivers);
    };

    const handleAddReceiver = () => {
        const newReceiver = { receiver_id: '', percentage: 0 };
        setReceivers([...receivers, newReceiver]);
    };

    const handleRemoveReceiver = (index) => {
        const newReceivers = receivers.filter((_, i) => i !== index);
        setReceivers(newReceivers);
    };

    const handleNew = () => {

        if (receivers.some(receiver => !receiver.receiver_id)) {
            setError('Todos os recebedores devem ser selecionados.');
            return;
        }

        const uniqueReceivers = new Set(receivers.map(r => r.receiver_id));
        if (uniqueReceivers.size !== receivers.length) {
            setError('Os recebedores devem ser distintos.');
            return;
        }

        const totalPercentage = receivers.reduce((sum, receiver) => sum + parseFloat(receiver.percentage), 0);

        if (totalPercentage !== 100) {
            setError('A soma dos percentuais precisa ser igual a 100%.');
            return;
        }

        setError('');
        setIsLoadingNew(true);

        api.post('/billet', {
            value: billetValue.split('.').join('').replace(',', '.'),
            due_date: dueDate,
            description,
            fine: parseFloat(fine) || 0,
            interest: parseFloat(interest) || 0,
            liquid_value: netValue,
            tax_receivers_value: cnpjFeeTotal,
            tax_value: billetValueFloat * taxRate,
            tax_percentage: userInfos.tax,
            receivers
        }, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("token")
            }
        })
        .then(res => {
            setBilletValue('');
            setReceivers([{ name: '', percentage: 0 }]);
            setIsLoadingNew(false);
            getBillets();
            setIsModalOpen(false);
            setSnackbar({
                message: 'Boleto criado com sucesso',
                type: 'success',
                visible: true,
            });
        })
        .catch(error => {
            setIsLoadingNew(false);
            setSnackbar({
                message: 'Erro ao criar boleto',
                type: 'error',
                visible: true,
            });
        });

    };

    useEffect(() => {
        getBillets();
    }, [])

    const getBillets = () => {

        setIsLoading(true);

        api.get('/billet', {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then(function (res) {
            setBillets(res.data);
            setIsLoading(false);
        })
        .catch(err => {
            setIsLoading(false);
        });

    }

    const taxRate = userInfos.tax / 100;
    const billetValueFloat = parseFloat(billetValue.split('.').join('').replace(',', '.')) || 0;
    const netValue = billetValueFloat - (billetValueFloat * taxRate);

    const cnpjFeePerReceiver = 2;

    const getReceiverType = (id) => {
        const receiver = receiversOptions.find(opt => opt.value == id);
        console.log("id: ", id);
        console.log("receiversOptions: ", receiversOptions);
        console.log("receiver: ", receiver);
        return receiver?.type || ''; // 'cnpj' ou 'cpf'
    };

    const cnpjCount = receivers.filter(r => getReceiverType(r.receiver_id) === 'cnpj').length;
    const cnpjFeeTotal = cnpjCount * cnpjFeePerReceiver;
    const adjustedNetValue = netValue - cnpjFeeTotal;

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const minDate = tomorrow.toISOString().split('T')[0];

    useEffect(() => {
        const updatedReceivers = receivers.map(receiver => {
            const value = parseFloat(adjustedNetValue) * (parseFloat(receiver.percentage) || 0) / 100;
            return { ...receiver, value };
        });
        setReceivers(updatedReceivers);
    }, [receivers.length, receivers.map(r => r.percentage).join(','), adjustedNetValue]);    

    return (
        <>
            <div className="bg-white shadow-md rounded-lg p-6">
                <div className={`flex ${isMobile ? 'flex-col items-start gap-2' : 'justify-between items-center'}`}>
                    <h6 className="text-xl">Boletos</h6>
                    <Button disabled={isLoading} onClick={() => setIsModalOpen(true)}>Novo boleto</Button>  {/* Abre o modal ao clicar */}
                </div>

                {/* Tabela de Últimos Boletos Criados */}
                {isLoading ? (
                    <div className="animate-pulse mt-4">
                        <div className="h-6 bg-gray-300 rounded w-3/4 mb-4"></div>
                        <div className="h-6 bg-gray-300 rounded w-full mb-4"></div>
                        <div className="h-6 bg-gray-300 rounded w-2/3"></div>
                    </div>
                ) : (
                    <div className="overflow-x-auto w-full">
                        <table className="min-w-full mt-4 table-auto border-collapse">
                            <thead>
                                <tr className="border-b">
                                    <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Valor</th>
                                    <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Taxa LucroTech</th>
                                    <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Data de Vencimento</th>
                                    <th className="py-2 px-4 text-left text-sm font-semibold text-gray-700">Status</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {billets?.map((billet, index) => (
                                    <React.Fragment key={index}>
                                        <ItemBillet billet={billet} />
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Modal de Novo Boleto */}
            <Modal 
                isOpen={isModalOpen} 
                onClose={() => setIsModalOpen(false)} 
                title="Novo boleto"
            >

                {userInfos?.tax ?
                    <>

                        {/* Campo de valor do boleto */}
                        <div className="mb-4">
                            <Input
                                label="Valor do Boleto"
                                fullWidth
                                type="text"
                                value={billetValue}
                                onChange={(e) => setBilletValue(formatCurrency(e.target.value))}
                                placeholder="R$ 0,00"
                            />
                            {billetValue && (
                                <>
                                    <p className='text-sm mt-2'>Taxa LucroTech ({userInfos?.tax}%): {parseFloat(billetValueFloat * taxRate).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                    <p className='text-sm mt-2'>Valor líquido split: {parseFloat(netValue).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                </>
                            )}
                            {cnpjCount > 0 && (
                                <p className='text-sm mt-2'>
                                    Taxa adicional por {cnpjCount} recebedor(es) CNPJ: {(cnpjFeeTotal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                </p>
                            )}
                        </div>

                        <div className="mb-4">
                            <Input
                                label="Data de vencimento"
                                fullWidth
                                type="date"
                                value={dueDate}
                                onChange={(e) => setDueDate(e.target.value)}
                                min={minDate}
                            />
                        </div>

                        <div className="mb-4">
                            <Input
                                label={
                                    <>
                                        <p>Descrição</p>
                                        <p className="text-[12px] text-gray-500">opcional</p>
                                    </>
                                }
                                fullWidth
                                type="textarea"
                                maxLength={500}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                placeholder="Ex: Pagamento referente ao serviço X"
                            />
                            <p className="text-xs text-gray-400 mt-1 text-right">{description.length}/500</p>
                        </div>

                        <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                            <Input
                                fullWidth
                                label={
                                    <>
                                        <p>Multa por atraso (%)</p>
                                        <p className="text-[12px] text-gray-500">opcional</p>
                                    </>
                                }
                                type="number"
                                value={fine}
                                onChange={(e) => setFine(e.target.value)}
                                placeholder="Ex: 2"
                            />
                            <Input
                                fullWidth
                                label={
                                    <>
                                        <p>Juros mensal por atraso (%)</p>
                                        <p className="text-[12px] text-gray-500">opcional</p>
                                    </>
                                }
                                type="number"
                                value={interest}
                                onChange={(e) => setInterest(e.target.value)}
                                placeholder="Ex: 0.33"
                            />
                        </div>

                        {/* Recebedores */}
                        <div className="mb-4">
                            <h3 className="text-sm font-semibold text-gray-700 mb-2">Recebedores</h3>
                            <hr className='mb-2' />
                            {receivers?.map((receiver, index) => (
                                <div key={index} className="flex flex-col md:flex-row gap-4 items-start md:items-center mb-4">
                                    <Input
                                        fullWidth
                                        label="Escolha o recebedor"
                                        type="select"
                                        options={receiversOptions}
                                        value={receiver.receiver_id}
                                        onChange={(e) => handleReceiverPercentageChange(index, e.target.value)}
                                    />
                                    <Input
                                        fullWidth
                                        label={`
                                            Percentual (%) -
                                            ${(
                                                parseFloat(adjustedNetValue) * (receiver.percentage / 100)
                                            ).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                        `}
                                        type="number"
                                        value={receiver.percentage}
                                        onChange={(e) => handleReceiverChange(index, e.target.value)}
                                        placeholder="%"
                                    />
                                    {/* Botão de excluir */}
                                    <Button onClick={() => handleRemoveReceiver(index)} variant='outlined' color='error' style={{ marginTop: !isMobile && '25px' }}>Excluir</Button>
                                </div>
                            ))}
                            {error && <p className="text-red-500 text-sm">{error}</p>}
                        </div>

                        {/* Botão para adicionar novo recebedor */}
                        <div className="mb-4">
                            <Button fullWidth={isMobile} onClick={handleAddReceiver} className="mt-4" variant='outlined' color='primary'>Adicionar Recebedor</Button>
                        </div>
                        
                        <Button
                            isLoading={isLoadingNew}
                            disabled={!billetValue || !dueDate}
                            fullWidth
                            onClick={handleNew}
                        >
                            Criar boleto
                        </Button>

                    </>
                :
                    <>
                        <p>Nosso time comercial está finalizando a liberação da sua conta e definirá a taxa de comissão mais adequada ao porte do seu negócio. Caso ainda não tenham entrado em contato, isso acontecerá em breve.</p>
                    </>
                }
                
            </Modal>
            {snackbar.visible && (
                <Snackbar
                    message={snackbar.message}
                    type={snackbar.type}
                    onClose={() => setSnackbar({ ...snackbar, visible: false })}
                />
            )}
        </>
    );
};

export default Billets;
